
import React from 'react'

const AuthenticationContext = React.createContext();

const AuthenticationContextProvider = (props) => {

    const [ test, setTest ] = React.useState("hello")

    return (
        <AuthenticationContext.Provider>
            {props.children}
        </AuthenticationContext.Provider>
    )
}

export default AuthenticationContextProvider;